import React from 'react';
import styled from 'styled-components';
import ViewContainer from 'components/ViewContainer';
import { Link, RouteComponentProps } from '@reach/router';
import { RFC } from 'state/StateTypes';

const Unauthorized: RFC<RouteComponentProps> = (): JSX.Element => (
   <ViewContainer>
      <Notification>
         <h3>You are not authorized to view this resource</h3> <br />
         <Link to="/profile">Return to your profile</Link>
      </Notification>
   </ViewContainer>
);

export default Unauthorized;

const Notification = styled.div`
   margin: 2em auto;
   padding: 1em;
   border-radius: 5px;
   text-align: center;
`;
